export default __webpack_public_path__ + "static/media/ps-bolt.75aab344.svg";